var aerobilet_overlay = (function() {
	
	var overlay = null;

	return {
		show : function(serviceType) {
			if (overlay == null) {
				overlay = $("#aerobilet_loader").dialog({
					modal : true,
					autoOpen : false,
					resizable : false,
					draggable : false,
					width: 550,
					height: 300,
					dialogClass : 'no-close'
				});
			}
			if(serviceType == "Hotel"){
				overlay.html('<div class="d-flex flex-column align-items-center">' +
					'<h5 class="mb-3">' + FmtMessage.getMessage('js.loading.hotel.text') + '</h5>' +
					'<img src="/images/entatil/icons/svg/loading.svg" class="mb-3" alt="loading">' +
					'</div>');
			}
			else{
				overlay.html('<div class="d-flex flex-column align-items-center">' +
					'<h5 class="mb-3">' + FmtMessage.getMessage('js.search.loading.process') + '</h5>' +
					'<img src="/images/entatil/icons/svg/loading.svg" class="mb-3" alt="loading">' +
					'</div>');
			}
			$(".ui-dialog-titlebar").hide();
			$("#filter_modal_loader,.ui-dialog-content").removeClass("ui-widget-content");
						
			overlay.dialog("open");
		},
		hide : function() {
			if (overlay != null) {
				$(".ui-dialog-titlebar").show();
				$("#filter_modal_loader,.ui-dialog-content").addClass("ui-widget-content");
				overlay.dialog("close");
			}
		}
	};
})();

function openLoaderBox(serviceType) {
	$("#aerobilet_loader").show();
	aerobilet_overlay.show(serviceType);
}

function closeLoaderBox() {
	aerobilet_overlay.hide();
}

function fillCountries(){
	$.ajax({
		url : "/jCountries",
		dataType : "json",
		async : false,
		success : function(data) {
			if (data != null) {
				var countriesOptions = "<option value=''>" + FmtMessage.getMessage('js.person.chooseCountry') + "</option>";

				$(data.countries).each(function(index, country) {
					countriesOptions += "<option value='" + country.code + "' data-title='" + country.country + "' data-image='/images/msdropdown/icons/blank.gif' data-imagecss='flag " + country.code + "' >" + country.country + "</option>";
				});

				$("[iType=fillCountry]").html(countriesOptions);
			}
		}
	});
}
var _globalCurrenyIcon='';
var siteCurrencies = {
	    'USD': '$', 
	    'EUR': '€',
	    'GBP': '£',
	    'TL' : '₺',
	    'TRY' : '₺',
	    'INR': '₹',
	    'UAH': '₴',
	    'ILS': '₪',
	    'EGP': '£',
        'SAR': '﷼',
        'BDT': '৳',
        'QAR': '﷼',
        'RUB': '₽',
        'CHF': '₣',
        'PLN': 'zł',
        'PKR': '',
        'AED': 'د.إ',
        'AZN': '₼',
        'IDH': '',
        'KWD': 'ك',
		'OMR': 'ريال',
		'IQD': 'دينار'
	};

function getSiteCurrencyIcon(){
	if(_globalCurrenyIcon=='') {
	  try 
  	  {
        var localCur = $.cookie('currency');
        if(typeof siteCurrencies[localCur]!=='undefined') {
	       var res= siteCurrencies[localCur];
	        if (typeof res!=='undefined' ) _globalCurrenyIcon= res; 
	     }
     	}
	  catch(err) {
	    return _result='' ;
	  }
	}
	return _globalCurrenyIcon;
}
function numberFormat(num,digit) {
	var _digit=  (typeof digit =='undefined')? 0:digit;  
	if(Math.round(num) == num) _digit=0;
	return (
		  Number(num)
	      .toFixed(_digit) 
	      .replace('.', ',') 
	      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') 
	  )
}
function currencyFormat(num)
{
  return numberFormat(num,2) +' '+getSiteCurrencyIcon();	
}

function currencyFormatZero(num)
{
  return numberFormat(num,0) +' '+getSiteCurrencyIcon();	
}

function isNullOrEmpty(string) {
	if (typeof string != 'string'){
		return true;
	}
	else if (string.length == 0){
		return true;
	}

	return false;
}

// mobileNav scrollJump Function //
function scrollJump(){
	var el = document.querySelector(".search-nav");
	
	var scrollVal = el.scrollLeft;
	if( scrollVal > 0 ){
		el.style.marginLeft = 0;
	}
}

